import API from "./baseApi";

const createForm = (payload) => {
  return API.post("/form/create", payload);
};

const updateForm = (payload) => {
  return API.post("/form/update", payload);
};

const getFormData = (payload) => {
  return API.post("/form/get", payload);
};


const deleteFormData = (id) => {
  return API.delete(`/form/${id}`);
};


const createFormMapping = (payload) => {
  return API.post("/form/mapping/create", payload);
};
const updateFormMapping = (payload) => {
  return API.put("/form/mapping/update", payload);
};
const getFormMapping = (payload) => {
  return API.post("/form/mapping/get", payload);
};
const deleteFormMapping = (data) => {
  return API.delete(`/form/mapping/delete/${data?.ID}`);
};


export default {
  createForm,
  updateForm,
  getFormData,
  deleteFormData,
  createFormMapping,
  updateFormMapping,
  getFormMapping,
  deleteFormMapping,
};
